import { getStore } from 'core_main/store';
import { InitializePubNubParameters } from 'core_main/pubnub/types';
import { debug, LogLabel } from 'globals/errors';

export const importAndInitializePubNub = (
  params?: InitializePubNubParameters,
) => {
  debug({ message: `importAndInitializePubNub called, hasParams: ${!!params}`, labels: [LogLabel.PUBNUB_RECOVERY] });
  // eslint-disable-next-line import/no-cycle
  return import(/* webpackChunkName: "pubnub" */ '../pubnub').then((pubnub) => {
    debug({ message: 'PubNub module imported', labels: [LogLabel.PUBNUB_RECOVERY] });
    if (!params) {
      debug({ message: 'No params provided, returning pubnub module', labels: [LogLabel.PUBNUB_RECOVERY] });
      return pubnub;
    }

    const { customerId, orgId, cb, forceReinitialize } = params;
    const store = getStore();
    debug({
      message: `Checking if PubNub is connected, isPubNubConnected: ${store.isPubNubConnected}, customerId: ${customerId}, orgId: ${orgId}`,
      labels: [LogLabel.PUBNUB_RECOVERY]
    });

    if (!store.isPubNubConnected || forceReinitialize) {
      debug({ message: 'PubNub not connected, calling initializePubNub', labels: [LogLabel.PUBNUB_RECOVERY] });
      return pubnub
        .initializePubNub({
          customerId,
          orgId,
          cb,
          forceReinitialize,
        })
        .then(() => {
          debug({ message: 'initializePubNub completed', labels: [LogLabel.PUBNUB_RECOVERY] });
          return pubnub;
        });
    }
    debug({ message: 'PubNub already connected, skipping initialization', labels: [LogLabel.PUBNUB_RECOVERY] });
    return pubnub;
  });
};
